import React from "react";
import GuideLayout from "../components/layout/GuideLayout";
import Section from "../components/layout/Section";
import Subheader from "../components/layout/Subheader";
import {
  Typography,
} from "@mui/material";
import BulletList from "../components/layout/BulletList";

const usage = [
  "You agree not to use anything from Stylisher for any illegal, harmful, or abusive activities.",
  "For Lebronbot, you must comply with Discord's Terms of Service and Community Guidelines.",
  "We reserve the right to suspend or ban Lebronbot access to any server or user at our sole and complete discretion.",
  "Please do not use our information or our services for your own projects without our express permission. Most likely, we would be happy to help you build something new or work something out! But please contact us prior to doing so.",
];

const sections = [
  { id: "terms", title: "Terms of Service" },
  {
    id: "description",
    title: "Description"
  },
  {
    id: "eligibility",
    title: "Eligibility"
  }, {
    id: "usage",
    title: "Usage"
  },
  {
    id: "server-permissions",
    title: "Server Permissions"
  },
  {
    id: "modifications",
    title: "Modifications"
  },
  {
    id: "termination",
    title: "Termination"
  },
  {
    id: "warranty-liability",
    title: "Warranty and Liability"
  },
  {
    id: "personal-use",
    title: "Personal Use Only"
  }
];

const Terms = () => {

  return (
    <GuideLayout sections={sections}>
      <Section id="terms" title="Terms of Service">
        <Typography
          variant="caption"
          color="secondary"
          sx={{ mt: -1, mb: 2, display: "block" }}
        >
          Last Updated: September 23, 2025 | Effective Date: June 23, 2025
        </Typography>

        <Typography paragraph>
          Welcome to the Stylisher Project! By using any of our services (website, scripts, Discord Bot "Lebronbot"), you agree to the following terms. If you do not agree, please exit the site immediately and do not use our services.
        </Typography>

        <Section>
          <Subheader id="description" title="1. Description" />
          The Stylisher project consists of resources and tools for Neocash trading and aims to make trading information more accessible to the community. As part of the overall project, Lebronbot is a Discord bot that provides information on historical Neocash trade data.
        </Section>

        <Section>
          <Subheader id="eligibility" title="2. Eligibility" />
          You must be at least 13 years old (or older if required by your local laws) to use and contribute data to Lebronbot. We do not knowingly collect or solicit personally identifiable information from children under thirteen. If we learn we have collected personal information from a child under thirteen, we will delete that information as quickly as possible.
        </Section>

        <Section>
          <Subheader id="usage" title="3. Usage" />
          <BulletList items={usage} />
        </Section>

        <Section>
          <Subheader id="server-permissions" title="4. Server Permissions (Lebronbot)" />
          By inviting Lebronbot to your server, you grant it the permissions necessary to function as intended. These permissions may include sending messages, reading messages, managing roles, or moderating content depending on the features you use.
        </Section>

        <Section>
          <Subheader id="modifications" title="5. Modifications" />
          <Typography paragraph>
            We may update or modify these Terms at any time. Continued use of any of the Stylisher resources after changes to these Terms means that you accept the new Terms. You are free to reject the Terms at any time; however, that means that you must cease using our tools and resources.
          </Typography>
        </Section>

        <Section>
          <Subheader id="rights" title="6. Termination" />
          <Typography paragraph>
            We may remove Stylisher at any time, for any reason, without notice. Likewise, we may remove Lebronbot or revoke access to it at any time, for any reason, without notice. We reserve the right to refuse service to users we feel are harmful to our community, at our sole discretion.
          </Typography>
        </Section>

        <Section>
          <Subheader id="warranty-liability" title="7. Warranty and Liability" />
          <Typography paragraph>
            Stylisher is provided "as is" without warranties of any kind. Game information may change at any time and may result in potential outdated information in articles. Lebronbot sources data from volunteered user reports, and values are drawn from that sample. As Lebronbot data is user-reported, we are not responsible for the accuracy of the information contained therein. You are responsible to check other sources (i.e. do a value check on the boards, use your own discretion) before completing a trade or making a purchase. We are not responsible for any losses incurred as a result of using Stylisher.
          </Typography>
        </Section>


        <Section>
          <Subheader id="personal-use" title="8. Personal Use Only" />
          <Typography paragraph>
            You may only use the information found on Stylisher for personal use only and cannot use Stylisher tools (including Lebronbot) to financially benefit. Content such as item names and Neopet images are fully owned by Neopets and we do not claim to own it. We are not affiliated with Neopets or in any way, shape, or form.
          </Typography>
        </Section>
      </Section>

    </GuideLayout>
  );
};

export default Terms;